import React, { useEffect } from "react";
import { FormControlLabel, FormGroup, Switch, Typography, Grid } from "@mui/material";
import { StepData, StepProps } from "..";
import { useStepData } from "../context";
import StepLayout from "./layout";
import { validateStep } from "./validation";

const StepValidate: React.FC<StepProps> = () => {
  const { stepData, setStepData, setStepName } = useStepData();

  if (!validateStep(stepData, "validate")) {
    return null;
  }

  const requiredText = "Date/time order required, with oldest applications at the top";
  const optionalText = "Date/time order not required";
  const toggleOrderValidation = () => {
    setStepData((prevData: StepData) => ({ ...prevData, validateOrder: !prevData.validateOrder }));
  };

  useEffect(() => {
    setStepName("Validate");
  }, []);

  return <StepLayout
    title="Validate your data"
    description={<Typography variant="body1">To ensure all key application information is correct, we validate your spreadsheet data.</Typography>}
  >
    <Grid size={{ xs: 12 }}>
      <Typography variant="body1">
        {stepData.data.length} applications were recognized in this file
      </Typography>
    </Grid>
    <Grid size={{ xs: 12 }}>
      <FormGroup>
        <FormControlLabel
          data-cy="validate-order"
          control={<Switch checked={stepData.validateOrder} onChange={toggleOrderValidation} />}
          label={stepData.validateOrder ? requiredText : optionalText} />
      </FormGroup>
    </Grid>
    <Grid size={{ xs: 12 }}>
      <Typography variant="body1">
        Position number required if date/time is not in order
      </Typography>
    </Grid>
    <Grid size={{ xs: 12 }}>
      <Typography variant="body1">
        We automatically validate unit size, household size, dates, emails, and phone numbers.
        <br/>
        Invalid emails and phone numbers will not be imported.
        <br/>
        Blank household sizes will automatically be updated to 1.
      </Typography>
    </Grid>
  </StepLayout>;
};

export default StepValidate;
